"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raiseClick = void 0;
var getDocument_1 = require("./getDocument");
/** Raises a click event.
 * @deprecated Moved to `FocusZone` component since it was the only place internally using this function.
 */
function raiseClick(target, doc) {
    var theDoc = doc !== null && doc !== void 0 ? doc : (0, getDocument_1.getDocument)();
    var event = createNewEvent('MouseEvents', theDoc);
    // eslint-disable-next-line deprecation/deprecation
    event.initEvent('click', true, true);
    target.dispatchEvent(event);
}
exports.raiseClick = raiseClick;
function createNewEvent(eventName, doc) {
    var event;
    if (typeof Event === 'function') {
        // Chrome, Opera, Firefox
        event = new Event(eventName);
    }
    else {
        // IE
        event = doc.createEvent('Event');
        // eslint-disable-next-line deprecation/deprecation
        event.initEvent(eventName, true, true);
    }
    return event;
}
//# sourceMappingURL=raiseClick.js.map